<div class="Frame802 self-stretch flex-col justify-start items-start gap-4 flex">
	<div class="DinaUppgifter text-black text-lg font-bold leading-loose">
		{{"PARKIFLY.SUMMARY.YOUR_BOOKING" | transloco}}
	</div>
	<div
		class="w-full rounded-[20px] border border-zinc-200 flex-col justify-start items-start inline-flex sm:min-w-[355px]">
		<div class="self-stretch flex flex-row items-center px-8 py-[10px] border-b border-zinc-200">
			<svg width="40" height="40" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
				<rect x="2.5" y="2.5" width="49" height="49" rx="24.5" fill="#0040DD" />
				<rect x="2.5" y="2.5" width="49" height="49" rx="24.5" stroke="url(#paint0_linear_2502_26137)"
					stroke-width="5" />
				<path
					d="M19.3375 15.9873C17.8375 15.9873 16.3356 17.1123 16.3356 19.3623L19.3375 25.3623L22.3375 19.3623C22.3375 17.1123 20.8375 15.9873 19.3375 15.9873ZM32.5703 17.8154C32.2469 17.829 31.9328 17.8904 31.6703 17.9467L31.8484 18.7717C32.1109 18.7131 32.3828 18.6761 32.6125 18.6592L32.5703 17.8154ZM19.3375 17.8623C20.1672 17.8623 20.8375 18.534 20.8375 19.3623C20.8375 20.192 20.1672 20.8623 19.3375 20.8623C18.5092 20.8623 17.8375 20.192 17.8375 19.3623C17.8375 18.534 18.5092 17.8623 19.3375 17.8623ZM33.5031 17.8717L33.3625 18.7014C33.5922 18.7496 33.8219 18.8101 34.0234 18.9311L34.4313 18.1904C34.1453 18.0381 33.8266 17.9012 33.5031 17.8717ZM30.8078 18.1857C30.5219 18.2973 30.2359 18.3971 29.9922 18.4951L30.325 19.2686C30.5828 19.1589 30.8547 19.0632 31.0844 18.9826L30.8078 18.1857ZM35.2 18.8139L34.5578 19.3623C34.7266 19.5554 34.8578 19.7936 34.9609 19.9857L35.7156 19.6061C35.5563 19.299 35.4156 19.0665 35.2 18.8139ZM29.2094 18.8561C28.9234 19.0018 28.6891 19.1317 28.4359 19.2592L28.8484 19.9998C29.0922 19.8592 29.3594 19.7232 29.575 19.6154L29.2094 18.8561ZM27.6953 19.6951C27.4469 19.8404 27.2031 19.9857 26.9641 20.1451L27.4234 20.8482C27.6531 20.6982 27.8922 20.5576 28.1266 20.417L27.6953 19.6951ZM36.0063 20.5342C35.7297 20.5811 35.4484 20.6139 35.1719 20.6467C35.1906 20.8811 35.1766 21.1342 35.1297 21.3311L35.95 21.5232C35.9969 21.1857 36.0391 20.8389 36.0063 20.5342ZM26.2516 20.6139C26.0172 20.7732 25.7875 20.9373 25.5531 21.0967L26.0406 21.7857C26.2656 21.6217 26.4953 21.467 26.725 21.3076L26.2516 20.6139ZM24.8641 21.6029C24.6297 21.7717 24.3859 21.9592 24.1844 22.1139L24.6953 22.7842C24.9531 22.5967 25.1313 22.4561 25.3656 22.2826L24.8641 21.6029ZM34.8484 21.9779C34.7078 22.1936 34.5438 22.4092 34.3797 22.5732L34.9938 23.1592C35.1953 22.9201 35.4109 22.6764 35.5609 22.4326L34.8484 21.9779ZM23.5141 22.6389C23.2844 22.817 23.0547 22.9998 22.8531 23.1686L23.3875 23.8201C23.6078 23.6373 23.8328 23.4498 24.0391 23.2998L23.5141 22.6389ZM33.7984 23.1123C33.5828 23.2857 33.3578 23.4545 33.1516 23.5951L33.6344 24.2889C33.8828 24.1201 34.1266 23.9373 34.3375 23.7686L33.7984 23.1123ZM22.2016 23.717C21.9813 23.8951 21.7703 24.0826 21.5547 24.2654L22.1031 24.9076C22.3141 24.7248 22.525 24.542 22.7406 24.3639L22.2016 23.717ZM32.4625 24.0451C32.2234 24.1857 31.975 24.3311 31.75 24.4529L32.1531 25.1982C32.4063 25.0436 32.6922 24.9076 32.9031 24.767L32.4625 24.0451ZM20.9125 24.8232C20.7016 25.0107 20.4953 25.1982 20.2844 25.3904L20.8516 26.0186C21.0578 25.8311 21.2688 25.6436 21.475 25.4561L20.9125 24.8232ZM31.0141 24.842C30.7656 24.9639 30.5172 25.0904 30.2688 25.2123L30.6297 25.9717C30.9203 25.8311 31.1359 25.7139 31.3984 25.592L31.0141 24.842ZM29.5141 25.5639C29.2563 25.6811 29.0078 25.7936 28.7453 25.9014L29.0875 26.6748C29.3453 26.5623 29.6031 26.4451 29.8609 26.3279L29.5141 25.5639ZM19.6656 25.9717C19.4266 26.1826 19.2602 26.3467 19.0422 26.5576L19.6375 27.167C19.8578 26.9561 20.0359 26.7732 20.2422 26.5951L19.6656 25.9717ZM27.9766 26.2436C27.7188 26.3514 27.4609 26.4639 27.2031 26.5717L27.5313 27.3545C27.7938 27.2467 28.0516 27.1342 28.3094 27.0217L27.9766 26.2436ZM26.425 26.8998C26.1672 27.0123 25.9094 27.1248 25.6469 27.2279L25.975 28.0107C26.2328 27.9029 26.4953 27.7904 26.7531 27.6826L26.425 26.8998ZM35.0875 27.2373C33.5875 27.2373 32.0875 28.3623 32.0875 30.6123L35.0875 36.6123L38.0875 30.6123C38.0875 28.3623 36.5875 27.2373 35.0875 27.2373ZM24.8688 27.5561C24.6016 27.6779 24.3203 27.7904 24.0906 27.8889L24.4234 28.667C24.7 28.5498 24.9625 28.4373 25.1969 28.3342L24.8688 27.5561ZM23.3125 28.2217C23.0594 28.3389 22.7641 28.4701 22.5391 28.5732L22.8859 29.342C23.1625 29.2201 23.4063 29.0982 23.65 28.9951L23.3125 28.2217ZM21.7656 28.9248C21.5031 29.0514 21.2313 29.1826 20.9969 29.2998L21.3766 30.0545C21.6297 29.9232 21.8922 29.8014 22.1219 29.6889L21.7656 28.9248ZM35.0875 29.1123C35.9172 29.1123 36.5875 29.7826 36.5875 30.6123C36.5875 31.442 35.9172 32.1123 35.0875 32.1123C34.2578 32.1123 33.5875 31.442 33.5875 30.6123C33.5875 29.7826 34.2578 29.1123 35.0875 29.1123ZM20.2375 29.6889C19.9891 29.8248 19.7406 29.9654 19.4875 30.1107L19.9094 30.842C20.1484 30.7014 20.3922 30.5701 20.6359 30.4389L20.2375 29.6889ZM18.7516 30.5654C18.4886 30.7154 18.2345 30.917 18.0156 31.0623L18.5266 31.7373C18.7595 31.5686 19.0103 31.3951 19.2109 31.2732L18.7516 30.5654ZM17.35 31.6248C17.125 31.8311 16.9033 32.0701 16.7313 32.2717L17.3734 32.8201C17.5539 32.5998 17.7109 32.4357 17.9219 32.2482L17.35 31.6248ZM27.5594 31.6857L27.6344 32.5248C27.8781 32.4826 28.1219 32.5107 28.3656 32.5482L28.5109 31.7186C28.2016 31.6717 27.8734 31.6389 27.5594 31.6857ZM25.8156 32.1545L26.1344 32.9373C26.3781 32.8295 26.6313 32.7451 26.8891 32.6654C26.8 32.3982 26.7344 32.1264 26.6641 31.8545C26.3688 31.9389 26.0734 32.0514 25.8156 32.1545ZM29.4484 32.1123L28.9703 32.8061C29.1672 32.9514 29.3594 33.1061 29.5141 33.2982L30.1516 32.7451C29.9125 32.5014 29.7297 32.2717 29.4484 32.1123ZM25.0188 32.5342C24.7609 32.6654 24.5125 32.8154 24.2641 32.9607L24.6906 33.6873C24.9344 33.5561 25.1734 33.4014 25.4125 33.2748L25.0188 32.5342ZM16.2161 33.0498C16.0745 33.3545 15.9597 33.6826 15.9062 33.9732L16.7359 34.1186C16.7866 33.8514 16.8592 33.6592 16.9656 33.4295C16.7083 33.317 16.4627 33.1811 16.2161 33.0498ZM23.5328 33.4154C23.2938 33.5701 23.0594 33.7248 22.825 33.8842L23.2938 34.5873C23.5281 34.4326 23.7578 34.2732 23.9922 34.1186L23.5328 33.4154ZM30.6906 33.4717L29.9828 33.9311C30.1328 34.1561 30.2781 34.3904 30.4141 34.6295L31.1453 34.2076C30.9813 33.9451 30.8641 33.7107 30.6906 33.4717ZM22.1266 34.3623C21.8922 34.517 21.6578 34.667 21.4281 34.8311L21.8969 35.5342C22.1219 35.3701 22.3609 35.2154 22.6 35.0561L22.1266 34.3623ZM16.7453 34.8076C16.4739 34.8639 16.2002 34.9107 15.9273 34.9623C15.9766 35.2904 16.1083 35.6092 16.2273 35.8623L16.9891 35.4967C16.8873 35.2623 16.7908 35.0186 16.7453 34.8076ZM31.5625 34.9389L30.8313 35.3607C30.9766 35.6139 31.1453 35.8857 31.2813 36.1014L31.9891 35.6467C31.8297 35.3982 31.6938 35.1639 31.5625 34.9389ZM20.7344 35.2904C20.5 35.4357 20.2703 35.5764 20.0266 35.7123L20.4438 36.4482C20.6922 36.3029 20.9406 36.1576 21.1797 36.0029L20.7344 35.2904ZM17.3922 36.0545L16.8156 36.6732C17.0763 36.9217 17.3978 37.0857 17.7484 37.1607L17.9359 36.3404C17.7278 36.2982 17.5333 36.1951 17.3922 36.0545ZM19.3141 36.0686C19.0792 36.1764 18.8355 36.2607 18.5828 36.3123L18.775 37.1373C19.0759 37.0764 19.3591 36.9639 19.6422 36.8467L19.3141 36.0686ZM32.4531 36.2936L31.8016 36.8232C32.0031 37.0717 32.2516 37.3107 32.4672 37.4795L32.9875 36.8139C32.7813 36.6545 32.6031 36.4623 32.4531 36.2936ZM33.5828 37.1139L33.3719 37.9342C33.7422 38.0092 34.0188 38.0326 34.3656 37.9951L34.2625 37.1561C34.0328 37.1936 33.8078 37.1701 33.5828 37.1139Z"
					fill="white" />
				<defs>
					<linearGradient id="paint0_linear_2502_26137" x1="27" y1="5" x2="27" y2="49"
						gradientUnits="userSpaceOnUse">
						<stop stop-color="#B2CCFF" />
						<stop offset="1" stop-color="#D1E6FF" />
					</linearGradient>
				</defs>
			</svg>
			<div class="Frame773 flex-col justify-end items-start gap-1 inline-flex m-4">
				<div
					class="LNgtidsparkering text-center text-blue-900 text-lg font-medium  leading-normal whitespace-nowrap">
					{{booking?.parking}}
				</div>
			</div>
		</div>
		<div class="self-stretch px-8 py-4 border-b border-zinc-200 justify-start items-start gap-2.5 inline-flex">
			<div class="self-stretch flex-col items-start inline-flex">
				<div class="flex">
					<div class="flex flex-col">
						<div class="w-[7px] justify-center items-center flex h-[21px]">
							<div class="w-[7px] h-[7px] bg-blue-700 rounded-[20px] mt-1"></div>
						</div>
						<div class="h-full w-[1px] bg-[#0040DD] mt-1 ml-[3px]"></div>
					</div>
					<div class="text-neutral-800 text-sm font-normal  leading-[21px] ml-3 mb-2">
						<span class="font-medium">{{((site?.toLowerCase() === 'flygets' ?
							"PARKIFLY.SUMMARY.ARRIVAL_AT_PARKING" :
							'PARKIFLY.SIMPLE_SEARCH_SELECT.DEPARTURE_HEADING') | transloco) + ": "}}</span>
						@if(booking?.parkingFromActual) {
						{{
						($safeNavigationMigration(booking?.parkingFromActual) | date:'yyyy-MM-dd') + " " +
						" " + ("PARKIFLY.CLOCK_SHORT" | transloco) + ": " + (
						$safeNavigationMigration(booking?.parkingFromActual)| date:'HH:mm')
						}}
						@if(booking?.departure) {
						@if(booking?.departure?.departureCode) {
						@let flightDetails = $safeNavigationMigration(booking?.departure);
						<div class="flex items-center">
							<svg width="12" height="11" viewBox="0 0 22 21" fill="none" class="ml-[6px]"
								xmlns="http://www.w3.org/2000/svg">
								<path
									d="M5.885 -7.05719e-05H8.085L13.0218 8.80103H18.7C18.7 8.80103 22 8.80103 22 10.3399C22 11.8799 18.7 11.8799 18.7 11.8799H13.0218L8.085 20.6799H5.885L8.6218 11.8799H4.6761L2.2 14.081H0L1.7611 10.341L0 6.59993H2.2L4.6761 8.80103H8.6218L5.885 -7.05719e-05Z"
									fill="black" />
							</svg>
							<div class="ml-[6px] text-[#6C757D]">
								{{ flightDetails?.arrivalStation + ", " +
								booking?.departure?.departureCode }}
							</div>
						</div>
						<div class="flex items-center">
							<svg width="12" height="11" viewBox="0 0 22 21" fill="none" class="ml-[6px] opacity-0"
								xmlns="http://www.w3.org/2000/svg">
								<path
									d="M5.885 -7.05719e-05H8.085L13.0218 8.80103H18.7C18.7 8.80103 22 8.80103 22 10.3399C22 11.8799 18.7 11.8799 18.7 11.8799H13.0218L8.085 20.6799H5.885L8.6218 11.8799H4.6761L2.2 14.081H0L1.7611 10.341L0 6.59993H2.2L4.6761 8.80103H8.6218L5.885 -7.05719e-05Z"
									fill="black" />
							</svg>
							<div class="ml-[6px] text-[#6C757D]">
								{{ ($safeNavigationMigration(flightDetails?.scheduledDeparture) | date:'yyyy-MM-dd') +
								" " + ("PARKIFLY.CLOCK_SHORT" | transloco) + ": " +
								((flightDetails ? $safeNavigationMigration(flightDetails?.scheduledDeparture) : '') |
								date:'HH:mm')
								}}
							</div>
						</div>
						}@else {
						<div class="flex items-center">
							<svg width="24" height="24" viewBox="0 0 24 24" fill="none"
								xmlns="http://www.w3.org/2000/svg">
								<path
									d="M9.27273 12.2728C10.1782 12.2728 10.9091 11.5419 10.9091 10.6365C10.9091 9.731 10.1782 9.00009 9.27273 9.00009C8.36727 9.00009 7.63636 9.731 7.63636 10.6365C7.63636 11.5419 8.36727 12.2728 9.27273 12.2728ZM15.8182 9.00009H11.4545V12.8183H7.09091V7.90918H6V16.091H7.09091V14.4546H16.9091V16.091H18V11.1819C18 9.97645 17.0236 9.00009 15.8182 9.00009Z"
									fill="black" />
							</svg>
							<div class="text-[#6C757D]">
								{{getDepartureTerminalName()}}
							</div>
						</div>
						}
						}
						}
					</div>
				</div>
				<div class="flex">
					<div class="w-[7px] justify-center items-center flex h-[21px]">
						<div class="w-[7px] h-[7px] bg-blue-700 rounded-[20px]"></div>
					</div>
					<div class="text-neutral-800 text-sm font-normal  leading-[21px] ml-3">
						<span class="font-medium">{{((site?.toLowerCase() === 'flygets' ? "PARKIFLY.SUMMARY.RETURN_TRIP"
							:
							'PARKIFLY.SIMPLE_SEARCH_SELECT.ARRIVAL_HEADING') | transloco) + ": "}}</span>
						@if(booking?.parkingTo) {
						{{
						($safeNavigationMigration(booking?.parkingTo) | date:'yyyy-MM-dd') + " " +
						" " + ("PARKIFLY.CLOCK_SHORT" | transloco) + ": " + (
						$safeNavigationMigration(booking?.parkingTo) | date:'HH:mm')
						}}
						@if(booking?.arrival) {
						@if(booking?.arrival?.arrivalCode) {
						@let flightDetails = $safeNavigationMigration(booking?.arrival);
						<div class="flex items-center">
							<svg width="12" height="11" viewBox="0 0 22 21" fill="none"
								xmlns="http://www.w3.org/2000/svg" class="ml-[6px] rotate-180">
								<path
									d="M5.885 -7.05719e-05H8.085L13.0218 8.80103H18.7C18.7 8.80103 22 8.80103 22 10.3399C22 11.8799 18.7 11.8799 18.7 11.8799H13.0218L8.085 20.6799H5.885L8.6218 11.8799H4.6761L2.2 14.081H0L1.7611 10.341L0 6.59993H2.2L4.6761 8.80103H8.6218L5.885 -7.05719e-05Z"
									fill="black" />
							</svg>
							<div class="ml-[6px] text-[#6C757D]">
								{{ flightDetails?.departureStation + ", " +
								booking?.arrival?.arrivalCode}}
							</div>
						</div>
						<div class="flex items-center">
							<svg width="12" height="11" viewBox="0 0 22 21" fill="none"
								xmlns="http://www.w3.org/2000/svg" class="ml-[6px] opacity-0">
								<path
									d="M5.885 -7.05719e-05H8.085L13.0218 8.80103H18.7C18.7 8.80103 22 8.80103 22 10.3399C22 11.8799 18.7 11.8799 18.7 11.8799H13.0218L8.085 20.6799H5.885L8.6218 11.8799H4.6761L2.2 14.081H0L1.7611 10.341L0 6.59993H2.2L4.6761 8.80103H8.6218L5.885 -7.05719e-05Z"
									fill="black" />
							</svg>
							<div class="ml-[6px] text-[#6C757D]">
								{{
								($safeNavigationMigration(flightDetails?.scheduledArrival) | date:'yyyy-MM-dd') +
								" " + ("PARKIFLY.CLOCK_SHORT" | transloco) + ": " +
								((flightDetails ? $safeNavigationMigration(flightDetails?.scheduledArrival) : '') |
								date:'HH:mm')
								}}
							</div>
						</div>
						}@else {
						<div class="flex items-center">
							<svg width="24" height="24" viewBox="0 0 24 24" fill="none"
								xmlns="http://www.w3.org/2000/svg">
								<path
									d="M9.27273 12.2728C10.1782 12.2728 10.9091 11.5419 10.9091 10.6365C10.9091 9.731 10.1782 9.00009 9.27273 9.00009C8.36727 9.00009 7.63636 9.731 7.63636 10.6365C7.63636 11.5419 8.36727 12.2728 9.27273 12.2728ZM15.8182 9.00009H11.4545V12.8183H7.09091V7.90918H6V16.091H7.09091V14.4546H16.9091V16.091H18V11.1819C18 9.97645 17.0236 9.00009 15.8182 9.00009Z"
									fill="black" />
							</svg>
							<div class="text-[#6C757D]">
								{{getArrivalTerminalName()}}
							</div>
						</div>
						}
						}
						}
					</div>
				</div>
			</div>
			<div class="self-stretch flex-col justify-between items-start inline-flex">
			</div>
		</div>
		<div class="self-stretch flex-col justify-start items-start flex py-3">
			@if(booking?.firstName && booking?.lastName){
			<div class="self-stretch px-8 py-2 justify-start items-start gap-2.5 inline-flex">
				<div class="self-stretch justify-start items-center gap-2.5 flex">
					<div class="self-stretch flex-col justify-between items-start inline-flex">
						<div class="w-[7px] flex-col justify-center items-center flex h-[21px]">
							<div class="w-[7px] h-[7px] relative bg-blue-700 rounded-[20px]"></div>
						</div>
					</div>
					<div class="flex-col justify-start items-start gap-2.5 inline-flex">
						<div class="text-neutral-800 text-sm font-normal  leading-[21px]">
							@if(this.booking?.organizationName?.toLowerCase() === 'nazar' ||
							this.booking?.organizationName?.toLowerCase() === 'tui') {
							<span class="font-medium">{{"PLACEHOLDER.LASTNAME" | transloco
								}}:</span>
							{{booking?.lastName}}
							} @else {
							<span class="font-medium">{{"PARKIFLY.SUMMARY.NAME" | transloco
								}}:</span>
							{{booking?.firstName +" "+ booking?.lastName}}
							}
						</div>
					</div>
				</div>
			</div>

			@if(this.booking?.organizationName?.toLowerCase() === 'nazar' ||
			this.booking?.organizationName?.toLowerCase() === 'tui') {
			<div class="self-stretch px-8 py-2 justify-start items-start gap-2.5 inline-flex">
				<div class="self-stretch justify-start items-center gap-2.5 flex">
					<div class="self-stretch flex-col justify-between items-start inline-flex">
						<div class="w-[7px] flex-col justify-center items-center flex h-[21px]">
							<div class="w-[7px] h-[7px] relative bg-blue-700 rounded-[20px]"></div>
						</div>
					</div>
					<div class="flex-col justify-start items-start gap-2.5 inline-flex">
						<div class="text-neutral-800 text-sm font-normal  leading-[21px]">

							<span class="font-medium">{{"PLACEHOLDER.ORDER_NUMBER" | transloco
								}}:</span>
							{{booking?.firstName}}
						</div>
					</div>
				</div>
			</div>
			}

			}
			@if(booking?.email){

			<div class="self-stretch px-8 py-2 justify-start items-start gap-2.5 inline-flex">
				<div class="self-stretch justify-start items-center gap-2.5 flex">
					<div class="self-stretch flex-col justify-between items-start inline-flex">
						<div class="w-[7px] flex-col justify-center items-center flex h-[21px]">
							<div class="w-[7px] h-[7px] relative bg-blue-700 rounded-[20px]"></div>
						</div>
					</div>
					<div class="flex-col justify-start items-start gap-2.5 inline-flex">
						<div class="text-neutral-800 text-sm font-normal  leading-[21px]">
							<span class="font-medium">{{"PARKIFLY.SUMMARY.EMAIL" | transloco }}:</span>
							{{booking?.email }}
						</div>
					</div>
				</div>
			</div>
			}

			@if(booking?.cellular) {
			<div class="self-stretch px-8 py-2 justify-start items-start gap-2.5 inline-flex">
				<div class="self-stretch justify-start items-center gap-2.5 flex">
					<div class="self-stretch flex-col justify-between items-start inline-flex">
						<div class="w-[7px] flex-col justify-center items-center flex h-[21px]">
							<div class="w-[7px] h-[7px] relative bg-blue-700 rounded-[20px]"></div>
						</div>
					</div>
					<div class="flex-col justify-start items-start gap-2.5 inline-flex">
						<div class="text-neutral-800 text-sm font-normal  leading-[21px]">
							<span class="font-medium">{{"PARKIFLY.SUMMARY.MOBILE_NUMBER" | transloco }}:</span>
							{{booking?.cellular}}
						</div>
					</div>
				</div>
			</div>
			}

			@if(booking?.carRegNumber) {

			<div class="self-stretch px-8 py-2 justify-start items-start gap-2.5 inline-flex">
				<div class="self-stretch justify-start items-center gap-2.5 flex">
					<div class="self-stretch flex-col justify-between items-start inline-flex">
						<div class="w-[7px] flex-col justify-center items-center flex h-[21px]">
							<div class="w-[7px] h-[7px] relative bg-blue-700 rounded-[20px]"></div>
						</div>
					</div>
					<div class="flex-col justify-start items-start gap-2.5 inline-flex">
						<div class="text-neutral-800 text-sm font-normal  leading-[21px]">
							<span class="font-medium">{{"PARKIFLY.SUMMARY.REGISTRATION_NUMBER" | transloco
								}}:</span>
							{{booking?.carRegNumber}}
						</div>
					</div>
				</div>
			</div>
			}

			@if(booking?.passengers) {

			<div class="self-stretch px-8 py-2 justify-start items-start gap-2.5 inline-flex">
				<div class="self-stretch justify-start items-center gap-2.5 flex">
					<div class="self-stretch flex-col justify-between items-start inline-flex">
						<div class="w-[7px] flex-col justify-center items-center flex h-[21px]">
							<div class="w-[7px] h-[7px] relative bg-blue-700 rounded-[20px]"></div>
						</div>
					</div>
					<div class="flex-col justify-start items-start gap-2.5 inline-flex">
						<div class="text-neutral-800 text-sm font-normal  leading-[21px]">
							<span class="font-medium">{{"PARKIFLY.SUMMARY.NUMBER_OF_TRAVELERS" | transloco
								}}:</span>
							{{booking?.passengers}}
						</div>
					</div>
				</div>
			</div>
			}
			@if(booking?.comment) {

			<div class="self-stretch px-8 py-2 justify-start items-start gap-2.5 inline-flex">
				<div class="self-stretch justify-start items-center gap-2.5 flex">
					<div class="self-stretch flex-col justify-between items-start inline-flex">
						<div class="w-[7px] flex-col justify-center items-center flex h-[21px]">
							<div class="w-[7px] h-[7px] relative bg-blue-700 rounded-[20px]"></div>
						</div>
					</div>
					<div class="flex-col justify-start items-start gap-2.5 inline-flex">
						<div class="text-neutral-800 text-sm font-normal  leading-[21px]">
							<span class="font-medium"> {{"PARKIFLY.SUMMARY.MESSAGE" | transloco }}: </span>
							{{booking?.comment }}
						</div>
					</div>
				</div>
			</div>
			}
		</div>

		<!-- Parking -->
		<div class="px-8 py-4 border-b border-t border-zinc-200 w-full">

			<p class="text-blue-900 text-base font-medium  leading-normal">
				{{"PARKIFLY.SUMMARY.PARKING" | transloco}}
			</p>
			<div class="gap-2.5 flex items-center">

				<div class="w-[7px] h-[7px] bg-blue-700 rounded-[20px]"></div>
				@if(booking?.parking) {
				<div class="font-medium text-sm flex justify-between w-full">
					<p class="self-center">
						{{ booking?.parking}} @if(freeShuttles) { {{"PARKIFLY.SUMMARY.FREE_TRANSFER" |
						transloco}}}
					</p>

					@if(booking?.parkingDiscountAmount > 0 || booking?.parkingDiscountPercent > 0) {
					<div class="text-right leading-none">
						<p class="text-xs text-red-600">
							@if(booking?.parkingDiscountPercent > 0) {
							(-{{booking?.parkingDiscountPercent}}%)
							}
							@if(booking?.parkingDiscountAmount > 0) {
							(-{{booking?.parkingDiscountAmount}} SEK)
							}
							{{ (booking?.parkingVatAmount +
							booking?.parkingAmount)?.toLocaleString(locale)}} SEK
						</p>
						<p>
							@if(booking?.parkingDiscountPercent > 0) {
							{{ ( (booking?.parkingVatAmount + booking?.parkingAmount) * ( 1 -
							booking?.parkingDiscountPercent / 100 ) )?.toLocaleString(locale)}} SEK
							}
							@if(booking?.parkingDiscountPercent > 0) {
							{{ ( (booking?.parkingVatAmount + booking?.parkingAmount) -
							booking?.parkingDiscountPercent )?.toLocaleString(locale)}} SEK

							}
						</p>
					</div>
					}@else {
					<p class="font-bold">
						{{ (booking?.parkingVatAmount + booking?.parkingAmount)?.toLocaleString(locale)}}
						SEK
					</p>
					}
				</div>
				}

			</div>

		</div>


		<!--Additional services-->
		@if( bookingDetails?.additionalServices.length) {

		<div class="px-8 py-4 w-full  border-b border-zinc-200">
			<p class="text-blue-900 text-base font-medium  leading-normal">
				{{"PARKIFLY.SUMMARY.ADDITIONAL_SERVICES" | transloco}}
			</p>

			@for(service of bookingDetails?.additionalServices; track service.name) {
			<div class="gap-2.5 flex items-center">
				<div class="w-[7px] h-[7px] bg-blue-700 rounded-[20px]"></div>
				<div class="font-medium text-sm flex w-full justify-between items-center">
					<p>
						{{service.name[locale]}}:
					</p>
					<p class="text-right font-bold">
						{{ (service.amount)?.toLocaleString('sv-SE')}} SEK
					</p>
				</div>
			</div>
			}
		</div>
		}

		<!--Additional products-->
		@if( booking?.additionalProducts?.length) {

		<div class="px-8 py-4 w-full  border-b border-zinc-200">
			<p class="text-blue-900 text-base font-medium  leading-normal">
				{{"PARKIFLY.PDF.RECEIPT.ADDITIONAL_PRODUCTS" | transloco}}
			</p>

			@for(service of booking.additionalProducts; track service.name) {
			<div class="gap-2.5 flex items-center">
				<div class="w-[7px] h-[7px] bg-blue-700 rounded-[20px]"></div>
				<div class="font-medium text-sm flex w-full justify-between items-center">
					<p>
						{{service.name}}:
					</p>
					<p class="text-right font-bold">
						{{ ((service.amount + service.vatAmount) *
						service.quantity)?.toLocaleString('sv-SE')}} SEK
					</p>
				</div>
			</div>
			}
		</div>
		}

		<div class="self-stretch border-t border-zinc-200 flex-col justify-start items-start flex pt-4 pb-4">
			<div class="self-stretch px-8 justify-start items-start gap-2.5 inline-flex">
				<div class="grow shrink basis-0 text-neutral-800 text-lg font-medium  leading-[27px]">
					{{'PARKIFLY.FORM.TOTAL_PRICE' | transloco}}</div>
				<div class="text-neutral-800 text-lg font-bold  leading-[27px]">
					@if(booking) {

					@if(booking.discountAmount > 0 || booking.discountPercent > 0) {

					<div class="text-neutral-800 text-lg font-bold  leading-[27px]">
						{{booking.totalDiscountPriceIncVat?.toLocaleString('sv-SE')}} SEK
					</div>

					}@else {
					<div class="text-neutral-800 text-lg font-bold  leading-[27px]">
						{{booking.totalPriceIncVat?.toLocaleString('sv-SE')}} SEK
					</div>
					}
					}
				</div>
			</div>

			<div class="self-stretch px-8 justify-start items-start gap-2.5 inline-flex">
				<div class="grow shrink basis-0 text-neutral-800 text-sm font-normal  leading-[21px]">
					{{"PARKIFLY.SUMMARY.VAT" | transloco}}
				</div>
				@if(booking) {
				@if(booking.discountAmount > 0 || booking.discountPercent > 0) {
				<div class="text-neutral-800 text-sm font-normal  leading-[21px]">
					{{
					booking.vatAmountDiscount?.toLocaleString('sv-SE', {maximumFractionDigits:0})
					}} SEK
				</div>

				}@else {
				<div class="text-neutral-800 text-sm font-normal  leading-[21px]">
					{{
					booking.totalVat?.toLocaleString('sv-SE', {maximumFractionDigits:0})
					}} SEK
				</div>
				}
				}
			</div>
		</div>
	</div>
</div>